import React from 'react';
import { createRoot } from 'react-dom/client';

import ParentSignup from '../routes/parent-signup';

// import ErrorBoundary from '../utils/error-boundary';
import { StyleSheetManager } from 'styled-components';

var prerender = navigator.userAgent && navigator.userAgent.includes("Prerender");
// inject css in DOM only when google bot, or any crawler tries to access the site.
// otherwise keep it false (default behaviour of styled components)
const App = () => {
  return (
    <StyleSheetManager disableCSSOMInjection={prerender}>
      <ParentSignup />
    </StyleSheetManager>
  );
};

// [AI GENERATED CODE] Updated to React 19 createRoot API
const root = createRoot(document.getElementById('parent-signup'));
root.render(<App />);
